<template>
  <div v-if="demo" class="demo-alert-container">
    <div class="demo-alert">
      <img src="~/assets/icons/material-warning.svg" alt="alert icon" style="height: 20px;">
      こちらは共用のデモ画面です。個人情報や園の情報を入力しないでください。
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useMe } from '~/composables/useMe'

const { me } = useMe()
const demo = computed(() => me.value.demo)
</script>

<style scoped>
.demo-alert-container {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  height: 100%;
  display: flex;
  align-items: center;
}
.demo-alert {
  background: #FF1300;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin: auto;
  font-size: 60%;
}
</style>
